import { Factory } from '../Factory';
import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';
import { IHttpWrapperService } from '../http';
import { INotificationService } from '../notification';
import { SortOperation } from '../../model/SortOperation';

import ITimeoutService = angular.ITimeoutService;

export interface IAuditLogParams extends IParams {
  page: number;
  limit: number;
  sortOperations: Array<SortOperation>;
}

export class AuditLogService implements IService {
  private ItemResource;

  constructor(rootScope: IRootScope, $resource: angular.resource.IResourceService, $timeout: ITimeoutService, private configService: IConfigService, resourceWrapperService: ResourceWrapperService, private httpService: IHttpWrapperService, notificationService: INotificationService) {
    $timeout(() => {
      const auditResource = $resource(`${configService.getServerBaseUrlForResource()}/auditing/project/:projectId`,
        {projectId: "@projectId"},
        {
          query: {method: "POST", params: {page: 1, limit: 50}}
        });

      this.ItemResource = resourceWrapperService.WrapActions(auditResource);
    });

    // AuditLogDownloadComplete is handled in React
    // (src/hooks/useAuditLog -> WebSocketBridge), including its toast.
  }

  public async FindAll(params: IAuditLogParams) {
    return this.ItemResource.query({
      projectId: params.projectId,
      page: params.page,
      limit: params.limit
    }, params.sortOperations).$promise;
  }

  public Audit(projectId, description: string, data) {
    this.httpService?.$http({
      method: 'POST',
      url: `${this.configService.getServerBaseUrl()}/auditing/project/${projectId}/description/${description}`,
      data: data
    });
  }

  public GetCSV(projectId: string) {
    let url = `${this.configService.getServerBaseUrl()}/auditing/csv/project/${projectId}`;

    return this.httpService.$http({
      method: 'GET',
      url: url
    });
  }
}

frontendApp.factory("AuditLogService", ["$rootScope", "$resource", "$timeout", "ConfigService", "ResourceWrapperService", "HttpService", "NotificationService", Factory.Create(AuditLogService)]);
